import { ProgressSpinner } from 'primereact/progressspinner';
const Smallloader = () =>{
    return(
        <ProgressSpinner style={{width: '14px', height: '14px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
    );   
}

export const Smallloadertrans = () =>{
    return(
        <ProgressSpinner style={{width: '14px', height: '14px'}} strokeWidth="8" fill="transparent" animationDuration=".5s" />
    );   
}

export default Smallloader;


// export const loader = {
//     Loadermd  
// };

// function  Loadermd(){
//    return(<ProgressSpinner style={{width: '14px', height: '14px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />);   
// }

